// Discover optional third photos without importing missing files.
const images = require.context("./image", false, /-3\.webp$/);
export default images;
